import mobx, { observable, action, computed, autorun } from 'mobx';
// import _ from 'lodash';
import Cookies from 'js-cookie';
import api from '../../api';
import appStore from '../appStore';
import AccountPage from './account';
import HistoryPage from './history';
import BetsPage from './betsPeriod';

class AutoCloseForm {
    SECONDS = 30; // время выхода когда нет авктивности
    store = null;
    timer = null;
    seconds = -1;
    status = 1;
	  bodyNode = document.getElementsByTagName('body')[0];

    constructor(store){
    	this.store = store;

	    autorun(() => {
	    	if (!this.store.access && this.store.showLoginForm) {
	        this.start();
	        this.bodyNode.addEventListener("mouseover", () => {
		      	this.setSeconds();
		      });
		      this.bodyNode.addEventListener("keydown", () => {
		      	this.setSeconds();
		      });
      	} else {
      		this.stop();
      	}
      })
    }

    setSeconds() {
        this.seconds = this.SECONDS;
    }

    start() {
      this.setSeconds();
      this.timer = setInterval(() => {
      	if (this.status) this.tick();
      }, 1000);
    }

    tick() {
      this.seconds--;

      if (this.seconds == 0) {
          this.store.toggleLoginFormVisible();
      }
    }

    stop() {
        clearInterval(this.timer);
    }
};

const SEC = 1000;
const MIN = 60 * SEC;
class InactiveTimer {
   constructor(timeout, onTimeOut) {
      this.time = timeout;
      const setTimer = () => { this.setTimer(onTimeOut); };
      document.addEventListener('mouseover', setTimer);
      document.addEventListener('keydown', setTimer);
      setTimer();
   }

   setTimer(onTimeOut) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(onTimeOut, this.time);
   }
}

class AutoLogout {
    COOKIE = 'logout_next_time';
    SECONDS = 1200; // время выхода когда нет авктивности
    store = null;
    timer = null;
    seconds = -1;
    status = 1;
    @observable alertVisible = 0;
    @observable timerVisible = {
    	status: 0,
    	html: ''
    };
    @observable countdownHtml = {
    	seconds: 0,
    	html: ''
    };
	  bodyNode = document.getElementsByTagName('body')[0];

   constructor(store) {
      this.store = store;

      autorun(() => {
         /** Принудительное очищение корзины при неактивности */
         new InactiveTimer(60 * MIN, () => { this.store.logout(null, { cleanup: true }); });
         if (this.store.access && !this.store.isCard) {
            if (this.isNeedToLogout()) {
               Cookies.remove(this.COOKIE);
               this.store.logout();
            }
            this.start();
            this.bodyNode.addEventListener("mouseover", () => {
               this.setSeconds();
            });
            this.bodyNode.addEventListener("keydown", () => {
               this.setSeconds();
            });
         } else {
            this.stop();
         }
      });
   }

    isNeedToLogout() {
        const c = Cookies.get(this.COOKIE);
        return typeof c !== 'undefined' && c == '1';
    }

    setSeconds() {
        this.seconds = this.SECONDS;
        this.timerVisible.status = 0;
        this.timerVisible.html = '';
    }

    start() {
      this.setSeconds();
      this.timer = setInterval(() => {
      	if (this.status) this.tick();
      }, 1000);
    }

    prepare(x) {
        return (x / 100).toFixed(2).substr(2);
    }

    countdown(seconds) {
    	this.countdownHtml.seconds = seconds;
    	this.countdownHtml.html = seconds == 1 ? 'SECONDS_OF1' : (seconds < 5 && seconds > 0 ? 'SECONDS_OF4' : 'SECONDS_OF');
    }

    hide() {
    	this.countdownHtml.seconds = 0;
    	this.countdownHtml.html = '';
    }

    print(min, sec) {
    	this.timerVisible.status = 1;
      this.timerVisible.html = '(' + (min < 10 ? '0' + min : min) + ':' + this.prepare(sec) + ')';
    }

    tick() {
        const w = 60;
        const sec = this.seconds % w;
        const min = (this.seconds - sec) / w;

        this.seconds--;

        if (this.seconds >= 0) {
            if (this.seconds <= 30) {
                this.print(min, sec);
            }
            if (this.seconds <= 10) {
            	this.alertVisible = 1;
            	this.countdown(this.seconds);
            } else {
            	this.alertVisible = 0;
            	this.hide();
            }
        } else {
            this.store.logout();
        }
    }

    @action stop() {
        clearInterval(this.timer);
    }
};

export class accountStore {
	@observable autoLogout = null;
	@observable isCard = 0;
	@observable changePsw = 0;
	@observable AccountPage = null;
	@observable BetsPage = null;
	@observable HistoryPage = null;
	@observable access = 0;
	@observable login = null;
	@observable showLoginForm = false;
	@observable lengthPhoneNumber = 10;
	@observable fastAmounts = {
		amounts: [100, 500, 1000],
		limits: {
			max: 999999,
			min: 50
		}
	}
	@observable auth = {
		cardID: '',
		phone: '',
		password: '',
		phone_prefix: '+7'
	}
	@observable logout_hash = '';
	@observable phoneMask = '(999) 999-99-99';
	@observable balance = 0;
	@observable countBets = 0;
	@observable result = {
		status: 0,
		text: '',
		type: 0
	};
	@observable disabledAuthForm = 0;
	@observable statusdAuthForm = {
		attempts: '~',
		error: '',
		status: 0,
		disabled: 0,
		wait: 0
	};

	@observable isBetSellModalOpened = false;
	@observable activeBetData = {};         // данные активной продаваемой ставки
	@observable activeBetSellingData = {};  // данные о продаже активной продаваемой ставки 
	@observable betsSellingData = {};       // данные с wss о всех ставках на продажу
	@observable sellingStatus = {           // статус продажи ставки
		step: 1,
		success: false,
		wait: false,
		isBlockedSell: false
	};

	subscribeCountBetsTimer = null;
	subscribeBetsTimer = null;
	subscribeBetsAttempt = 0;

	@observable accountSettings = {
		clearBasketAfterBet : 0,
		loadRossLive : 0,
		highlightChangesLive : 1,
		colorizeSport : 1,
		basketAgreeCf : 0,
		showHeaderBalance : 1,
		oneClickBet : 0,
		oneClickBetAmount : 0,
		showPopup : 1,
		showBetPopup : 0,
		// linePrintMode : 1,
		gamesNumber : 1,
		basketPosition : 'right',
		// TODO КОСТЫЛЬ: 1 - значит подсказка была показана
		is_basket_tooltip_visible: 1,
		tooltip_union_stat_match: 0
	}
	@observable hideRoutes = [];

	autoCloseForm = null;

	constructor() {
		this.AccountPage = new AccountPage(this);
		this.autoLogout = new AutoLogout(this);
		this.autoCloseForm = new AutoCloseForm(this);
		this.BetsPage = new BetsPage(this);
	}

	@action hideBalance(){
		if (this.accountSettings.showHeaderBalance === 1){
			this.accountSettings.showHeaderBalance = 0;
		} else this.accountSettings.showHeaderBalance = 1;
	}

	@action init() {
		if (this.access) {
			const ls = JSON.parse(localStorage.getItem(`account_settings`));
			if (ls && ls.login == this.login) {
				this.accountSettings = ls.settings;
			} else {
				localStorage.clear();
				this.saveSettings();
			}
			this.subscribeCountBets();
			this.subscribeBets();
		}
	}

	@action subscribeCountBets() {
		clearTimeout(this.subscribeCountBetsTimer);
		if (appStore.igStore.ws && appStore.igStore.ws.readyState === WebSocket.OPEN) {
			appStore.igStore.ws.send(
				JSON.stringify({
					t: 14,
					d: Cookies.get('jwt'),
					op: 0,
				})
			)
		} else {
			appStore.igStore.getSocket();
			this.subscribeCountBetsTimer = setTimeout(() => this.subscribeCountBets(), 1000);
		}
	}

	@action unsubscribeCountBets() {
		if (appStore.igStore.ws && appStore.igStore.ws.readyState !== WebSocket.CLOSED) {
			appStore.igStore.ws.send(
				JSON.stringify({
					t: 14,
					op: 1,
				})
			)
		}
	}

	@action updateCountBets = count => {
		if(!!count) {
			this.countBets = count;
		} else {
			this.countBets = 0;
		}
	}

	@action subscribeBets() {
    clearTimeout(this.subscribeBetsTimer);
		if (appStore.igStore.ws && appStore.igStore.ws.readyState === WebSocket.OPEN) {
			appStore.igStore.ws.send(
				JSON.stringify({
					t: 28,
					d: Cookies.get('jwt'),
					op: 0,
				}));
		} else {
			if (this.subscribeBetsAttempt < 5) {
				this.subscribeBetsAttempt++;
				appStore.igStore.getSocket()
				this.subscribeBetsTimer = setTimeout(() => this.subscribeBets(), 1000);
			} else {
				this.subscribeBetsAttempt = 0
			}
		}
	}

	@action unsubscribeBets() {
		if (appStore.igStore.ws && appStore.igStore.ws.readyState !== WebSocket.CLOSED) {
			appStore.igStore.ws.send(JSON.stringify({
				t: 28,
				op: 1,
			}));
			this.activeBetSellingData = {};
			this.resetSelling();
		}
	}

	@action updateBets = bets => {
		if (bets.diff === false) {
			this.betsSellingData = bets
		} else {
			this.betsSellingData =  {...this.betsSellingData, ...bets}
		}
	}

	@action openBetSellModal(value) {
		this.isBetSellModalOpened = value;
	}

	@action setBetSellData(data, sellingData) {
		this.activeBetData = data;
		this.activeBetSellingData = sellingData;
	}

	@action resetSelling() {
		this.sellingStatus = {
			step: 1,
			success: false,
			wait: false,
			isBlockedSell: false
		};
		this.clearResult();
	}

	@action updatePrice = (wagerId) => {
		this.activeBetSellingData = {
			...this.activeBetSellingData,
			price: this.betsSellingData[wagerId].price
		};
	}

	@action sellBet(wagerId, amount) {
		this.sellingStatus.wait = true;
		return api.user
			.sellBet(wagerId, amount)
			.then(
				action(res => {
					if (res.code === 'OK') {
						if (res.result.is_sold) {
							this.sellingStatus = {
								step: 2,
								success: true,
								wait: false,
								isBlockedSell: false,
							};
						} else {
							switch (res.result.key) {
								case 'cashout__amount_changed':
									this.updatePrice(wagerId);
									break;
								case 'cashout__not_allowed':
									this.sellingStatus = {
										step: 1,
										success: false,
										isBlockedSell: true,
									};
									break;
								default:
									this.sellingStatus = {
										step: 1,
										success: false,
										isBlockedSell: false,
									};
									break
							}
							this.sellingStatus.wait = false;
						}
						this.setResult(res.result.message);
					}
				}),
			)
			.catch(
				action(() => {
					this.setResult('SERVER_TEMPORARILY_DOWN');
				}),
			);
	}

	@action saveSettings() {
		if (this.access && this.login) {
			localStorage.setItem(`account_settings`, JSON.stringify({ login: this.login, settings: this.accountSettings }));
		}
	}

	@action closeForm() {
		this.phoneMask = '(999) 999-99-99';
		this.lengthPhoneNumber = 10;
		this.auth = {
			cardID : '',
			phone: '',
			password: '',
			phone_prefix: '+7'
		}
		this.clearAuthError();
	}

	toggleLoginFormVisible() {
		this.showLoginForm = false;
		this.closeForm();
	}

	@action inputAuth(val, type) {
		const number = val.replace(/\D+/g,"");
    this.statusdAuthForm.status = 0;
		switch(type) {
			case 'phone':
      	if (number.toString().length > 0){
      		this.auth.phone = number;
	      } else {
	        this.auth.phone = '';
	      }
				break;
			case 'password':
				if (number.toString().length > 0){
      		this.auth.password = number;
	      } else {
	        this.auth.password = '';
	      }
				break;
		}
	}

	@action setPrefix(prefix) {
		this.auth.phone_prefix = prefix;
		if(prefix === "+38") {
			this.correctPhone();
			this.phoneMask = '(999) 999-99-9';
			this.lengthPhoneNumber = 9;
		} else if(prefix === "+375") {
			this.correctPhone();
			this.phoneMask = '(99) 999-99-99';
			this.lengthPhoneNumber = 9;
		} else if(prefix === "+373") {
			this.correctPhone();
			this.phoneMask = '(99) 99-99-99';
			this.lengthPhoneNumber = 8;
		} else {
			this.phoneMask = '(999) 999-99-99';
			this.lengthPhoneNumber = 10;
		}
	}

	@action correctPhone() {
		if (this.auth.phone.toString().length > 8) {
			this.auth.phone = parseInt(this.auth.phone.toString().slice(0, -1));
		}
	}

	@action setCardId(cardID) {
		this.auth.cardID = cardID;
	}

	@action toggleLoginForm(x) {
		if (typeof x === 'undefined') {
			this.showLoginForm = !this.showLoginForm;
		} else {
			this.showLoginForm = x;
		}
	}

	@action sentLogin() {
		this.statusdAuthForm.disabled = 1;
		this.clearAuthError();
		this.statusdAuthForm.wait = 1;
		const data = {
			phone: this.auth.phone,
			password: this.auth.password,
			phone_prefix: this.auth.phone_prefix
		}
		return api.auth.login(data).then(
				action(
					res => {
						if (res.code == 'OK') {
							Cookies.set('user_logged_in', 1);
							this.access = 1;
							this.login = res.result.login;
							this.logout_hash = res.result.logout_hash;
							this.showLoginForm = false;
							this.changePsw = res.result.change_psw;
							this.hideRoutes = res.result.hide_routes;
							if (res.result.one_click_sum) this.accountSettings.oneClickBetAmount = res.result.one_click_sum;
							if (res.result.fast_amount) {
								this.fastAmounts.amounts = res.result.fast_amount.data;
								this.fastAmounts.limits = res.result.fast_amount.rules;
							}

							const {game} = appStore.igStore;
							appStore.igStore.close();
							if (game) {
								appStore.igStore.setGame(game, null);
							}
							// this.saveSettings();
							// window.location = '/live';
							appStore.initApp();
							this.init();
							if (!this.changePsw) {
								appStore.history.push('/live');
							}
						} else if (res.code == 'ERROR') {
							if (parseInt(res.result.attempts) >= 0) {
								this.statusdAuthForm.attempts = res.result.attempts;
							} else {
								this.statusdAuthForm.attempts = '~';
							}
							this.setAuthError(res.text ? res.text : 'Сервер недоступен');
						}
					}
				)
			)
			.catch(action(err => {
				this.setAuthError('Сервер недоступен');
      }))
      // .finally(action(() => { this.statusdAuthForm.disabled = 0; }));
	}

	@action cardLogin() {
		this.clearAuthError();
		this.statusdAuthForm.wait = 1;
		this.statusdAuthForm.disabled = 1;
		const data = {
			card_id : this.auth.cardID,
			password : this.auth.password
		}
		return api.auth.loginCard(data).then(
				action(
					res => {
						if (res.code == 'OK') {
							Cookies.set('user_logged_in', 1);
							this.access = 1;
							this.login = res.result.login;
							this.logout_hash = res.result.logout_hash;
							// window.location = '/live';
							this.isCard = 1;
							this.changePsw = res.result.change_psw;
							this.init();
							if (!this.changePsw) {
								appStore.history.push('/live');
							}
							// this.saveSettings();
						} else if (res.code == 'ERROR') {
							if (parseInt(res.result.attempts) >= 0) {
								this.statusdAuthForm.attempts = res.result.attempts;
							} else {
								this.statusdAuthForm.attempts = '~';
							}
							this.setAuthError(res.text ? res.text : 'INCORRECT_PASSWORD');
						}
					}
				)
			)
			.catch(action(err => {
				this.setAuthError('SERVER_TEMPORARILY_DOWN');
      }))
      // .finally(action(() => { this.statusdAuthForm.disabled = 0; }));
	}

	@computed get showChangePass() {
		return appStore.terminalAccess && this.access && this.changePsw;
	}

	@action setAuthError(text) {
		this.statusdAuthForm.status = 1;
		this.statusdAuthForm.text = text;
		this.statusdAuthForm.wait = 0;
		this.statusdAuthForm.disabled = 0;
	}

	@action clearAuthError() {
		this.statusdAuthForm.status = 0;
		this.statusdAuthForm.text = '';
		this.statusdAuthForm.disabled = 0;
		this.statusdAuthForm.wait = 0;
	}

	@action logout(card, { cleanup } = { cleanup: false }) {
		/** Чистим корзину, только если был авторизован, либо принудительно */
		(this.access || cleanup) && appStore.lineStore.basket.newClearBasketAfterBet();
		return api.auth.logout(this.logout_hash).then(
			action(
				res => {
					if (res.code == 'OK') {
						Cookies.set('user_logged_in', 0);
						// localStorage.removeItem(`account_settings_${this.login}`);

						this.access = 0;
						this.isCard = 0;
						this.logout_hash = '';
						appStore.igStore.handleLogout();
						this.unsubscribeCountBets();
						this.unsubscribeBets();
						// localStorage.clear();
						if (!card) window.location = '/';
					}
				}
				)
			)
			.catch(action(err => {

      }))
	}

	@action toggleAccountSettings(k, v) {
		this.accountSettings[k] = v;
		this.saveSettings();
	}

	// @computed get basketModifier(){
	// 	// this.accountSettings.clearBasketAfterBet =
	// 	basketStore.setData();
	// }

	@action initPage(type) {
		if (type == 'account') {
			this.AccountPage.init();
		} else if (type == 'history') {
			this.HistoryPage = new HistoryPage(this);
		} else if (type == 'bets') {
			// this.BetsPage = new BetsPage(this);
			this.BetsPage.init();
		}
	}

	@action clear(type) {
		if (type) {
			this[type].clear = null;
		} else {
			// this.AccountPage = null;
			this.HistoryPage = null;
			this.BetsPage.despose();
		}
	}

	@action getBalance() {
		return api.user.getBalance().then(
			action(
					res => {
						if (res.code == 'OK') {
							this.balance = res.result.balance;
						}
					}
				)
			)
	}

	@observable waitFastForm = false;

	@action setFastAmount(amounts, callback) {
		if (!this.access) {
			this.setResult('AUTH_ERROR');
			return false;
		}
		this.clearResult();

		if (amounts.every((el, index) => this.fastAmounts.amounts[index] === el )) {
      this.setResult('NO_CHANGES');
      return false;
    }

		this.waitFastForm = true;
    api.user.setFastAmount({data: amounts}).then(
			action(
				res => {
					if (res.code == 'OK') {
						this.fastAmounts.amounts = res.result;
						callback();
					} else {
						this.setResult(res.text ? res.text : 'SERVER_TEMPORARILY_DOWN');
					}
				}
			)
		)
		.catch(action(err => {
			this.setResult('SERVER_TEMPORARILY_DOWN');
    }))
    .finally(action(() => { this.waitFastForm = false; }));
  }

  @action setResult(text, type) {
		this.result.status = 1;
		this.result.text = text;
		this.result.type = type ? type : 0;
	}

	@action clearResult() {
		this.result.status = 0;
		this.result.text = '';
		this.result.type = 0;
	}

	@computed get getHideRoutes() {
		return this.hideRoutes || [];
	}
}

export default new accountStore();


// WEBPACK FOOTER //
// ./src/stores/accountStore/index.js